<template>
  <div class="fts-automation-query-display">
    <div 
      ref="content" 
      class="automation-query-display-container" 
      :class="{'automation-query-display-container--expand': isExpand}"
    >
      <fts-automation-query-display-item 
        v-for="item in filterItems" 
        :key="item.id" 
        :information="information" 
        :states="states" 
        :variables="variables" 
        :filter="item" 
      />
    </div>

    <div class="automation-query-display-more" v-if="isExpand">
      <div class="automation-query-display-more-btn" @click.stop="isExpand = false">show less</div>
    </div>

    <div class="automation-query-display-more automation-query-display-more--glass" v-else-if="isOverflowing">
      <div class="automation-query-display-more-btn" @click.stop="isExpand = true">show more</div>
    </div>
  </div>
</template>

<script>
import queryLogic from '../../commons/queryLogic';
import { store as canvasDesignStore } from '../../store/canvasDesignStore';

import FTSAutomationQueryDisplayItem from './FTSAutomationQueryDisplayItem';

export default {
  props: {
    moduleId: [String, Number],
    variables: Array,
    filter: Object
  },
  components: {
    "fts-automation-query-display-item": FTSAutomationQueryDisplayItem
  },
  data: () => ({
    information: [],
    isOverflowing: false,
    isExpand: false
  }),
  methods: {
    async findModuleVariable() {
      const result = await canvasDesignStore.dispatch("findVariable", {
        moduleId: this.moduleId
      });

      if (result) {
        let information = [];

        if (Array.isArray(result.information)) {
          information = result.information;
        }

        this.information = [
          ...queryLogic.querySelectionPrefix,
          ...information
        ];
      }
    },
    checkOverflow() {
      const el = this.$refs.content;
      if (!el) return;

      this.isOverflowing = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
    }
  },
  computed: {
    states() {
      return canvasDesignStore.getters.workspaceStates.filter(x => x.module == this.moduleId);
    },
    filterItems() {
      return this.filter && Array.isArray(this.filter.items) ? this.filter.items : [];
    }
  },
  watch: {
    moduleId() {
      this.findModuleVariable();
    },
    filterItems: {
      handler() {
        this.$nextTick(() => {
          this.checkOverflow();
        });
      },
      deep: true
    }
  },
  mounted() {
    if (this.moduleId) {
      this.findModuleVariable();
    }

    this.$nextTick(() => {
      this.checkOverflow();
    });
  }
}
</script>

<style lang="scss" scoped>
.fts-automation-query-display {
  position: relative;
  .automation-query-display-container {
    max-height: 150px;
    max-width: 100%;
    overflow: hidden;
    &.automation-query-display-container--expand {
      max-height: unset;
      overflow: visible;
    }
  }
  .automation-query-display-more {
    display: flex;
    align-items: center;
    justify-content: center;
    &.automation-query-display-more--glass {
      position: absolute;
      bottom: -2px;
      left: -2px;
      right: -2px;
      height: 50px;
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.7),
        rgba(255, 255, 255, 0.9),
        rgba(255, 255, 255, 1),
      );
    }
  }
  .automation-query-display-more-btn {
    display: inline-flex;
    margin-top: 0.75rem;
    margin-right: 1.25rem;
    padding: 0.125rem 0.5rem;
    border: 1px solid var(--fts-border);
    border-radius: 10em;
    color: var(--fts-default);
    cursor: pointer;
    &:hover {
      color: var(--fts-text);
    }
  }
}
</style>